import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import OrderDetails from './components/WithdrawOrderView';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { LinearProgress, SnackbarContent, Tooltip } from '@mui/material';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import { showNotification } from 'src/shared/components/Notification';
import PreviewIcon from '@mui/icons-material/Preview';
import OrderDetailsShippingViewDetailsModal from 'src/containers/PnD/Order/OrderCreation/View/components/OrderDetailsShippingViewDetailsModal';

const OrderDetailsIndex = () => {
  useEffect(() => {
    getAllWithdrewOrdersDetails();

  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);

  const getAllWithdrewOrdersDetails = async () => {
    try {
      setLoading(true);
      let Obj = {};
      const response = await PndRestApi.GetAllWithdrewOrders(Obj);
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) { //No Record Found
        setNoRecordFound(true);
      } else {

        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response?.data?.status}`,
          `Message: ${response?.data?.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };



  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 65,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row indexc
      },
      {
        Header: 'Tracking No.',
        accessor: 'orderNumber',
        disableGlobalFilter: false,
      },
      {
        Header: 'Invoice No.',
        accessor: 'invoiceNo',
        disableGlobalFilter: true,
      },
      {
        Header: 'Order Date Time',
        accessor: 'createdDateTime',
        disableGlobalFilter: false,
      },
      // {
      //   Header: 'Ecom Order No.',
      //   accessor: 'salesOrderNo',
      //   disableGlobalFilter: false,
      // },
      // {
      //   Header: 'Merchant Name',
      //   accessor: 'merchantInfo.merchantName',
      //   disableGlobalFilter: false,
      // },
      	
      {
        Header: 'Pick Up From',
        accessor: 'fromName	',
        disableGlobalFilter: false,
      },
      {
        Header: 'Pick Up Address',
        accessor: 'pickupAddress',
        disableGlobalFilter: false,
      },
      {
        Header: 'Drop Off To',
        accessor: 'toName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Drop Off Address',
        accessor: 'dropOffAddress',
        disableGlobalFilter: false,
      },
      
      
      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        Cell: row => (
          <div className="icon-style" >
            
            <Tooltip title="Click here to View the Order Details">
              <PreviewIcon style={{ cursor: "pointer" }} onClick={() => viewDetails(row.row.original)} />
            </Tooltip>
          </div>
        ),
      },

    ],
    [],
  );
  const viewDetails = async (event) => {
    if (event?.orderId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("View-Order Details")
    }

  }
  return (
    <Container>

      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && <OrderDetails reactTableData={reactTableData} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {isNoRecordFound && <OrderDetails isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}
      {viewDetailPopup &&
        <OrderDetailsShippingViewDetailsModal modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          dataInfo={temp}
          isTitle={isTitle} />
      }
    </Container>
  );
};

export default OrderDetailsIndex;